// extracted by css-extract-rspack-plugin
export default {"menuButton":"ExtraMenu-module__menuButton__IyeJz"};